import { apiNWL, apiController, restartApiCotroller } from '@/utils/nwlApi';
import store from '@/redux/store';
import { setShowLoader } from '@/redux/slices/loaderSlice';

const getMapAssets = async (orgId, locId, start, end, isPrimary) => {
    try {
        restartApiCotroller();
        store.dispatch(setShowLoader(false));
        const response = await apiNWL.get(
            `/organisations/${orgId}/locations/${locId}/assets?primary=${isPrimary}&start=${start}&end=${end}`,
            {
                signal: apiController.signal,
            },
        );
        return response.data || {};
    } catch (error) {
        console.error(error);
    }
};

export {
    getMapAssets
};